import type { Doc } from "building-types/doc";
import type { DocEntityType } from "building-types/doc/docEntityTypes";
import type { DocEntityTypeToValueType } from "building-types/entities/docEntityTypeToValueType";
import { mergeIn } from "common/utils/objectUtils";
import { docEntityTypeToDocTableName } from "./entity/docEntityTypeToDocTableName";

export function docUpdateEntity<T extends DocEntityType>(
  doc: Doc,
  type: T,
  id: string,
  props: Partial<DocEntityTypeToValueType[T]>,
): Doc {
  return mergeIn(doc, [docEntityTypeToDocTableName[type] as keyof Doc, id], props);
}
